import { Box } from "@mui/material";
import React from "react";
import { Fragment } from "react";
import cssClasses from "./WingSettings.module.css";
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import { useState } from "react";
import { useEffect } from "react";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { UpdateWingSettings, uploadWingLogo } from "../../Services/Project";
import { errorTost, successTost } from "../../Services/Toast";
import _ from "lodash";
import CustomSwitch from "../../Subcomponents/CustomSwitch";
import galleryImg from "../../Assets/Images/Common/gallery.svg";

// NEW (Cost Sheet Format Redesign, Phase 3): same helper DigitalCostSheet.jsx uses for its banner
// image upload, duplicated here since this codebase has no shared utils module exporting it.
// Wing logo is never displayed larger than ~200px anywhere it's used (Wing Settings preview box,
// Cost Sheet PDF), so uploads are downscaled to fit 400x200 (2x for sharpness) to keep the
// generated Cost Sheet PDF small. Only shrinks — never upscales a smaller logo.
const WING_LOGO_MAX_WIDTH = 400;
const WING_LOGO_MAX_HEIGHT = 200;

// Same pattern used in Login.jsx/AddDetails.jsx/EnterEmailModal.jsx: duplicated locally rather
// than shared, since this codebase has no shared utils module exporting it.
function isEmailValid(inputText) {
  let flag = true;
  let helperText = "";
  var mailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (inputText && !inputText.match(mailFormat)) {
    flag = false;
    helperText = "Please Enter Email in Proper Format";
  }
  return { flag, helperText };
}

function convertImageFileToWebFile(file) {
  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => {
      const scale = Math.min(
        WING_LOGO_MAX_WIDTH / image.naturalWidth,
        WING_LOGO_MAX_HEIGHT / image.naturalHeight,
        1
      );
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(image.naturalWidth * scale);
      canvas.height = Math.round(image.naturalHeight * scale);
      canvas.getContext("2d").drawImage(image, 0, 0, canvas.width, canvas.height);
      canvas.toBlob((blob) => {
        resolve(new File([blob], `${file.name.split(".")[0]}.webp`, { type: blob.type }));
      }, "image/webp");
    };
    image.crossOrigin = "anonymous";
    image.src = URL.createObjectURL(file);
  });
}

const WingSettings = ({ allWings, getWings }) => {
  const [wings, setWings] = useState([]);

  useEffect(() => {
    if (!allWings || allWings.length === 0) return;
    const mapped = allWings.map((val) => ({
      wingName: val?.wingId?.wingName,
      wingId: val?.wingId?.wingId,
      displayName: val?.wingId?.displayName
        ? val?.wingId?.displayName
        : val?.wingId?.wingName,
      termsAndCondition: val?.wingId?.termsAndCondition,
      crmHeadName: val?.wingId?.CRMHeadName,
      crmHeadEmail: val?.wingId?.CRMHeadEmail,
      checkVirtualAccount: val?.wingId?.checkVirtualAccount,
      logoUrl: val?.wingId?.logoUrl,
      logoFile: null
    }));
    setWings(_.uniqBy(mapped, "wingId"));
  }, [allWings]);

  async function updateWingSettingCall(val = null, index) {
    try {
      presentLoader();
      let payload = { ...val };
      if (payload.logoFile) {
        const webpFile = await convertImageFileToWebFile(payload.logoFile);
        payload.logoUrl = await uploadWingLogo(webpFile, payload.wingId);
      }
      const updateWingResponse = await UpdateWingSettings(payload);
      if (updateWingResponse.data?.length > 0) {
        index === wings?.length - 1 &&
          successTost("Wings Changes Successfully.");
        index === wings?.length - 1 && getWings();
      } else {
        throw updateWingResponse.data;
      }
      dismissLoader();
    } catch (error) {
      if (error?.error?.message) {
        index === wings?.length - 1 && errorTost(error?.error?.message);
      } else {
        index === wings?.length - 1 &&
          errorTost("Something went wrong! Try again");
      }
      dismissLoader();
    }
  }

  const handleSaveWings = () => {
    presentLoader();
    wings?.forEach((val, index) => {
      updateWingSettingCall(val, index);
    });
  };

  return (
    <div className={cssClasses.wingContainer}>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {wings?.map((val, wingIndex) => {
          return (
            <div key={val?.wingId}>
              <Box width={"22rem"} mb={"1.5rem"}>
                <CustomInput
                  disabled={true}
                  label={"Wing Name"}
                  placeholder={val?.wingName}
                  inputType={"number"}
                />
              </Box>
              <div className={cssClasses.wingWrapper}>
              <Box width={"22rem"}>
                <CustomInput
                  value={val?.displayName}
                  label={"Display Wing Name"}
                  placeholder={""}
                  inputType={"text"}
                  handleChange={(_value) => {
                    const index = wings?.findIndex(
                      (v) => v.wingId === val?.wingId
                    );
                    const payload = [...wings];
                    payload[index].displayName = _value;
                    setWings(payload);
                  }}
                />
              </Box>

              <Box width={"22rem"}>
                <CustomInput
                  value={val?.termsAndCondition}
                  label={"Terms and Condition"}
                  placeholder={""}
                  inputType={"text"}
                  handleChange={(_value) => {
                    const index = wings?.findIndex(
                      (v) => v.wingId === val?.wingId
                    );
                    const payload = [...wings];
                    payload[index].termsAndCondition = _value;
                    setWings(payload);
                  }}
                />
              </Box>

              <Box width={"22rem"}>
                <CustomInput
                  value={val?.crmHeadName}
                  label={"CRM Head Name"}
                  mandatory={true}
                  placeholder={""}
                  inputType={"text"}
                  handleChange={(_value) => {
                    const index = wings?.findIndex(
                      (v) => v.wingId === val?.wingId
                    );
                    const payload = [...wings];
                    payload[index].crmHeadName = _value;
                    setWings(payload);
                  }}
                />
              </Box>

              <Box width={"22rem"}>
                <CustomInput
                  value={val?.crmHeadEmail}
                  label={"CRM Head Email"}
                  mandatory={true}
                  placeholder={""}
                  inputType={"email"}
                  helperText={isEmailValid(val?.crmHeadEmail).helperText}
                  handleChange={(_value) => {
                    const index = wings?.findIndex(
                      (v) => v.wingId === val?.wingId
                    );
                    const payload = [...wings];
                    payload[index].crmHeadEmail = _value;
                    setWings(payload);
                  }}
                />
              </Box>

              <Box>
                <div className={cssClasses.toggleLabel} style={{ marginBottom: "1rem" }}>
                  Check Virual Account
                </div>
                <CustomSwitch
                  checked={val?.checkVirtualAccount}
                  onChange={(event) => {
                    const index = wings?.findIndex(
                      (v) => v.wingId === val?.wingId
                    );
                    const payload = [...wings];
                    payload[index].checkVirtualAccount = event.target.checked;
                    setWings(payload);
                  }}
                />
              </Box>
              <Box>
                <div className={cssClasses.toggleLabel} style={{ marginBottom: "0.5rem" }}>
                  Wing Logo<span style={{ color: "red" }}> *</span>
                </div>
                <div
                  style={{
                    width: 120,
                    height: 70,
                    border: "1px dashed #98A2B3",
                    borderRadius: 8,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    overflow: "hidden",
                  }}
                  onClick={() => {
                    document.getElementById(`wingLogoUpload-${val.wingId}`).click();
                  }}
                >
                  {val?.logoFile || val?.logoUrl ? (
                    <img
                      src={
                        val?.logoFile
                          ? URL.createObjectURL(val.logoFile)
                          : process.env.REACT_APP_SUPABASE_BUCKET_PREFIX + val.logoUrl
                      }
                      alt=""
                      style={{ maxWidth: "100%", maxHeight: "100%" }}
                    />
                  ) : (
                    <img src={galleryImg} alt="" style={{ width: 24, height: 24, opacity: 0.5 }} />
                  )}
                  <input
                    hidden
                    type="file"
                    accept="image/*"
                    id={`wingLogoUpload-${val.wingId}`}
                    onChange={(e) => {
                      if (e.target.files[0]) {
                        const index = wings?.findIndex(
                          (v) => v.wingId === val?.wingId
                        );
                        const payload = [...wings];
                        payload[index].logoFile = e.target.files[0];
                        setWings(payload);
                      }
                    }}
                  />
                </div>
              </Box>
              </div>
              {wingIndex !== wings.length - 1 && (
                <hr
                  style={{
                    border: "none",
                    borderTop: "3px solid #101828",
                    margin: "2rem 0 0 0",
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
      <Box width={"fit-Content"} ml={"auto"} mt={"10px"}>
        <Button
          style={{
            fontSize: "1.6rem",
            lineHeight: "2.4rem",
            color: "#FFF",
            backgroundColor: "#155EEF",
            borderRadius: "0.8rem",
          }}
          padding={"0.8rem 2.6rem"}
          btnName={"Save Changes"}
          disable={
            wings.filter((val) => val?.displayName === "")?.length > 0 ||
            wings.filter((val) => !isEmailValid(val?.crmHeadEmail).flag)?.length > 0
          }
          clicked={handleSaveWings}
        />
      </Box>
    </div>
  );
};

export default WingSettings;
